/**
 * Need a toast that only shows up once, and then closes itself?
 * This Toast will close itself, once the command is set to close.
 * This Toast will close itself, and show itself again when asked.
 */
import {CONSTANTS, Toast} from './Toast'

const defaultSettings = {
  position: CONSTANTS.POSITIONS.TOP_RIGHT
}

class OneToast {
  constructor (setupOptions) {
    this.toast = new Toast(setupOptions || defaultSettings)
  }

  success (options) {
    this.toast.destroy()
    this.toast.success({...this.setupOptions, ...options})
  }

  warning (options) {
    this.toast.destroy()
    this.toast.warning({...this.setupOptions, ...options})
  }

  error (options) {
    this.toast.destroy()
    this.toast.error({...this.setupOptions, ...options})
  }

  info (options) {
    this.toast.destroy()
    this.toast.info({...this.setupOptions, ...options})
  }

  destroy () {
    this.toast.destroy()
  }

}

export default OneToast



// WEBPACK FOOTER //
// ./src/app/components/common/toasts/OneToast.js